export const color = {
  accentLightest: '#bfdcee',
  accentLighter: '#37d8e6',
  accentLight: '#09b8ec',
  accent: '#0ca6d5', // NOTHS blue
  accentDark: '#0a9ecf',
  accentDarker: '#0a89af',
  accentDarkest: '#056582',

  primaryDarker: '#333', // Dark Grey
  primaryDark: '#414141', // Medium Grey
  primary: '#686868', // Light Grey
  primaryLight: '#e0e0e0', // BorderColor Light Grey
  primaryLighter: '#eeeeee', // BorderColor Extra Light Grey

  cerulean: '#00A3EB',
  pictonBlue: '#56BFED',

  mineShaft: '#2E2E2E',
  silverChalice: '#A3A3A3',
  silver: '#C5C5C5',
  suvaGrey: '#888',
  emperor: '#555',
  ebb: '#EAE8E6',
  alabaster: '#FBFBFB',

  wildWatermelon: '#FF6174',

  white: '#fff', // White color
  black: '#000', // Black

  background: '#f4f6f6', // Background colour for mobile dividers

  overlayGrey: '#3a3a3a',
  pampas: '#F6F5F3',
  cadetBlue: '#AEBCC6',
  slateGray: '#7b8a94',
};

export const nothsTheme = {
  color,
  font: {
    family: {
      primary: `'NOTHS3', 'Helvetica Neue', HelveticaNeue, Arial, sans-serif`, // Noths regular font
      secondary: `'NOTHS2', 'Helvetica Neue', HelveticaNeue, Arial, sans-serif`, // Noths bold font
      tertiary: `TimesNewRoman, 'Times New Roman', Times, Baskerville, Georgia, serif`, // Serif font
      quote: `Baskerville, Georgia, TimesNewRoman, 'Times New Roman', Times, serif`, // Quotation font
    },
    size: {
      XXS: '12px',
      XS: '13px',
      S: '16px',
      M: '18px',
      L: '20px',
      XL: '24px',
      XXL: '34px',
      XXXL: '42px',
    },
  },
  space: { XXS: '1px', XS: '4px', S: '8px', M: '16px', L: '24px', XL: '32px', XXL: '40px' },
  borderRadius: '3px',
};
